var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('QuickNavigation',{attrs:{"fileData":_vm.fileData,"routeHistory":_vm.$route}}),_c('UploadEmbeddedDocsDropzone',{attrs:{"notify":true}}),_c('LoanDetailSubMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }